<div class="page-container">

  <div class="container">

    <div class="row">

      <div class="col-12 col-md-4" *ngFor="let item of galleries">
        <div class="gallery-item" (click)="openGallery(item)">
          <div class="gallery-item-bg" [ngStyle]="getGalleryBackGroundImage(item)"></div>
          <app-section-heading class="section-heading" [noMargin]=true [small]="true"[label]="item.title"></app-section-heading>
        </div>
      </div>

    </div>

  </div>
</div>


<ng-image-fullscreen-view
  [images]="galleryImageList"
  [imageIndex]="0"
  [show]="showFlag"
  (close)="closeEventHandler()"></ng-image-fullscreen-view>
